import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const verifyGst = createAsyncThunk('verifyGst/verifyGst', async (data) => {
 
    try {
        const res = await axios({
            method: 'POST',
            url: process.env.REACT_APP_API_URL + `get_gstin_details`,
            data: {
                gstin: data
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return res
    } catch (error) {
        return error.response
    }
})

